import React from 'react';
import Button from '../ui/Button';
import StatusBanner from '../ui/StatusBanner';

function ReviewActionBar({
  reviewNote,
  onReviewNoteChange,
  onApprove,
  onDeny,
  isSubmitting,
  pendingAction,
  errorMessage
}) {
  const approving = isSubmitting && pendingAction === 'approve';
  const denying = isSubmitting && pendingAction === 'deny';

  return (
    <div className="role-review-actions">
      <StatusBanner kind="error" message={errorMessage} className="role-inline-message" />
      <StatusBanner
        kind="loading"
        message={isSubmitting ? (pendingAction === 'deny' ? 'Submitting denial...' : 'Submitting approval...') : ''}
        className="role-inline-message"
      />
      <label className="role-review-note">
        Denial Note
        <textarea
          value={reviewNote}
          onChange={(event) => onReviewNoteChange(event.target.value)}
          placeholder="Optional denial reason for the request history."
          disabled={isSubmitting}
        />
      </label>
      <div className="director-table-actions">
        <Button
          size="sm"
          disabled={isSubmitting && !approving}
          loading={approving}
          loadingLabel="Approving…"
          onClick={onApprove}
        >
          Approve Request
        </Button>
        <Button
          size="sm"
          variant="danger"
          disabled={isSubmitting && !denying}
          loading={denying}
          loadingLabel="Denying…"
          onClick={onDeny}
        >
          Deny Request
        </Button>
      </div>
    </div>
  );
}

export default ReviewActionBar;
